







































































































































































































































import {Mixins, Component, Watch} from 'vue-property-decorator';

import PageTitle from '@/components/common/PageTitle.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import Modify from '@/components/accumulation/mixins/PaymentRequestModify';

@Component({
  components: {PageTitle, DateCalendar}
})
export default class PaymentRequestModify extends Mixins(Modify) {
  @Watch('theModifyData.notificationChannels.length', {immediate: false, deep: false})
  length(next: number) {
    this.checkAllCheck(next);
  }
  @Watch('setNotification')
  getSetNotification(oldv: any, newV: any) {
    if (!newV) {
      this.$nextTick(() => {
        if (!this.noticeTimeFlag && this.isModify) {
          this.noticeTimeFlag = true;
          return;
        }
        this.notificationYmdt = this.paymentYmdt;
      });
    }
  }

  @Watch('targetTypeAll')
  targetTypeAllChange(next: any): void {
    if (next && this.theModifyData.mallNo) {
      this.getAllTargets();
      this.targetType = 'ALL';
    } else {
      this.theTargetCount = 0;
    }
  }
  @Watch('eligibilitySet')
  eligibilitySetChange(next: any): void {
    if (!next) {
      this.excludeNum = 0;
      this.excludeMembers = [];
    }
  }

  // 적립금 지급 사유. 최대길이
  private reasonMaxLength = 200;

  ////////////////////////////////////////////////
}
